import { useState } from 'react';
import { Box, Typography, Alert } from '@mui/material';
import ConfigCard from '../shared/ConfigCard';
import useCveStatuses from '../../hooks/useCveStatuses';

function CVETab() {
  const { 
    cveStatuses, 
    error: statusError,
    updateStatus 
  } = useCveStatuses();
  
  const [loadingCves, setLoadingCves] = useState({});
  const [cveError, setCveError] = useState(null); 

  const handleAttackToggle = async (cveName) => {
    setCveError(null);
    const isCurrentlyEnabled = cveStatuses[cveName]?.enabled;

    setLoadingCves(prev => ({ 
      ...prev, 
      [cveName]: true 
    }));

    const success = await updateStatus(cveName, !isCurrentlyEnabled);
    
    if (!success) {
      setCveError(`Failed to ${isCurrentlyEnabled ? 'disable' : 'enable'} ${cveName}`);
    }
    
    setLoadingCves(prev => ({ 
      ...prev, 
      [cveName]: false 
    }));
  };


  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        CVE Configurations
      </Typography>
      
      {(cveError || statusError) && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {cveError || statusError}
        </Alert>
      )}
      
      <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
        General Configurations
      </Typography>
      {Object.keys(cveStatuses)
        .map((cveName) => (
          <ConfigCard
            key={cveName}
            title={cveName}
            enabled={cveStatuses[cveName]?.enabled || false}
            loading={loadingCves[cveName]}
            onToggle={() => handleAttackToggle(cveName)}
          />
        ))}
    </Box>
  );
}

export default CVETab; 